import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showConfirmationModal } from "../../features/confirmationModal/ConfirmationModalSlice";
import DeleteActionIcon from "../icons/DeleteActionIcon";
import EditActionIcon from "../icons/EditActionIcon";
import styles from "./oneTournamentDetailsTemplate.module.css";

const STRUCTURE_SECTIONS = [
  { key: "qualification", label: "التصفيات" },
  { key: "semifinals", label: "نصف النهائي" },
  { key: "finals", label: "النهائيات" },
];

const RULES_SECTIONS = [
  { key: "identity", label: "الهوية" },
  { key: "behavior", label: "السلوك" },
  { key: "attendance", label: "الحضور" },
  { key: "fairPlay", label: "اللعب النزيه" },
];

const countPoints = (group, key) =>
  Array.isArray(group?.[key]) ? group[key].length : 0;

// One template row in the list: name + per-section point counts + edit/delete.
// All actions are gated by the templates tab's permission.
const OneTournamentDetailsTemplate = ({ template }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { rolePermissions } = useSelector((state) => state.user);

  const canManage = rolePermissions.includes("control-tournament-templates");
  const structure = template?.structure || {};
  const rules = template?.rules || {};

  const handleEdit = () => {
    navigate("/dashboard/tournaments/edit-tournament-details-template", {
      state: { template },
    });
  };

  const handleDelete = () => {
    dispatch(
      showConfirmationModal({
        message: `هل انت متاكد من حذف القالب : ${template?.name} ؟`,
        data: template?._id,
        actionType: "deleteTournamentDetailsTemplate",
      }),
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{template?.name || "-"}</h2>
        <p className={styles.subtitle}>قالب تفاصيل بطولة</p>
      </div>

      <div className={styles.groups}>
        <section className={styles.group}>
          <span className={styles.groupLabel}>هيكل البطولة</span>
          <div className={styles.chips}>
            {STRUCTURE_SECTIONS.map((section) => (
              <div className={styles.chip} key={section.key}>
                <span className={styles.chipLabel}>{section.label}</span>
                <span className={styles.chipValue}>
                  {countPoints(structure, section.key)} نقطة
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.group}>
          <span className={styles.groupLabel}>قوانين البطولة</span>
          <div className={styles.chips}>
            {RULES_SECTIONS.map((section) => (
              <div className={styles.chip} key={section.key}>
                <span className={styles.chipLabel}>{section.label}</span>
                <span className={styles.chipValue}>
                  {countPoints(rules, section.key)} نقطة
                </span>
              </div>
            ))}
          </div>
        </section>
      </div>

      {canManage && (
        <div className={styles.actionsSection}>
          <span className={styles.actionsTitle}>الإجراءات</span>
          <div className={styles.actionsGrid}>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.editAction}`}
              onClick={handleEdit}
            >
              <EditActionIcon className={styles.actionIcon} />
              <span>تعديل القالب</span>
            </button>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.deleteAction}`}
              onClick={handleDelete}
            >
              <DeleteActionIcon className={styles.actionIcon} />
              <span>حذف القالب</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OneTournamentDetailsTemplate;
